import styled from 'styled-components';
interface ItemProps {
  readonly theme?: string;
}

export const Radio = styled.label<ItemProps>`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 13px;
  padding: 2px 0px;

  & svg {
    opacity: ${props => (props.theme === 'button' ? '0' : '1')};
    width: ${props => (props.theme === 'button' ? '0' : 'auto')};
    display: ${props => props.theme === 'button' && 'none'};
  }
  & input {
    margin: 0 5px 0 0;
  }
  & input + span {
    border-radius: ${props => (props.theme === 'button' ? '8px' : '')};
    padding: ${props => (props.theme === 'button' ? '15px 15px' : '')};
    margin-right: ${props => (props.theme === 'button' ? '19px' : '')};
  }

  & span {
    background-color: ${props => (props.theme === 'button' ? '#F7F8FA' : '')};
  }

  & input:checked + span {
    background-color: ${props => (props.theme === 'button' ? '#EBEDF2' : '')};
    color: ${props => (props.theme === 'button' ? '#5D6E81 !important' : '')};
    font-weight: ${props => (props.theme === 'button' ? '600 !important' : '')};
  }
`;

export const RadioText = styled.span`
  color: var(--DarkGray);
  width: max-content;
  font-size: 16px;
  padding: 2px 8px;
`;

export const RadioInput = styled.input`
  display: none;
  visibility: hidden;
  width: 0;
  height: 0;
`;
